import React from 'react';

import { Order } from '@betterment/shared-components/src/components/activity/components/drawer/transactionTypes/Order';

import { ActivityReportsUrl } from './common/ActivityReportsUrl';
import { AdvisoryFee } from './transactionTypes/AdvisoryFee';
import { AllocationChange } from './transactionTypes/AllocationChange';
import { Deposit } from './transactionTypes/Deposit';
import { Other } from './transactionTypes/Other';
import { Trade } from './transactionTypes/Trade';
import { Transfer } from './transactionTypes/Transfer';
import { Withdrawal } from './transactionTypes/Withdrawal';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';

export const Drawer: React.FC<{ item: ActivityItemFragment }> = ({ item }) => {
  switch (item.__typename) {
    case 'ActivityItemDeposit':
      return <Deposit item={item} />;
    case 'ActivityItemWithdrawal':
      return <Withdrawal item={item} />;
    case 'ActivityItemOther':
      return <Other item={item} />;
    case 'ActivityItemTradeGroup':
      return <Trade item={item} />;
    case 'ActivityItemTransferGroup':
      return <Transfer item={item} />;
    case 'ActivityItemAllocationChange':
      return <AllocationChange item={item} />;
    case 'ActivityItemFee':
      return <AdvisoryFee item={item} />;
    case 'ActivityItemOrder':
      return (
        <Order
          item={item}
          activityReportsLink={
            item.activityReportsUrl ? <ActivityReportsUrl url={item.activityReportsUrl} /> : undefined
          }
        />
      );
    default: {
      const exhaustiveCheck: never = item;
      return exhaustiveCheck;
    }
  }
};
